import React, { useContext, useEffect, useRef, useState } from 'react'
import { useDispatch, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { Modal, Panel } from 'rsuite';

import LoaderComponent from '../../../CommonComponents/LoaderComponent'
import SupplyInformation from './information'
import SupplyCardAcceptance from './card-acceptance'
import SupplyAchAcceptance from './ach-acceptance'
import SupplyCheckAcceptance from './check-acceptance'
import SupplyChildVendor from './child-vendor'
import SupplierHistoricalPayments from './historical-payments'
import MasterSupplierHistory from './master-supplier-history'
import ModalComponent from '../../../CommonComponents/Modal'
import CreateChildVendorFromMaster from './createChildVendorFromMaster'
import { getChildSuppliersWithMasterId, updateCompletenessScore, updateSupplierBasicInfo, updateSupplierCardInfo, updateSupplierPaymentInfo } from '../../../../redux/actions/vendor'
import MasterSupplierHealth from './master-supplier-health'
import { toast } from '../../../CommonComponents/ToastComponent/toast'
import CreateContact from '../../../ContactsComponent/createContact'
import Contacts from '../../../ContactsComponent/contacts'
import { getContacts } from '../../../../redux/actions/contact'
import { AppContext } from '../../../../context';

const SupplyComponent = ({ checkedRelatedSupplierData, masterSupplierId, collapsiblePanel, qaStatus = '', isFromExistingMaster = false, onConfirmClick = () => { }, callers }) => {
  const store = useStore().getState()
  const dispatch = useDispatch()
  const basicInfoSaveBtnRef = useRef(null)
  const cardInfoSaveBtnRef = useRef(null)
  const achInfoSaveBtnRef = useRef(null)
  const {
    getSubscriptions
  } = useContext(AppContext);
  const {
    vendor: {
      isLoadingMasterDetail,
      isLoadingChildSupplier,
      masterSupplierDetails,
      isLoadingSupplierContacts
    },
    auth: { user }
  } = store

  const history = useHistory()
  const [isCollapsiblePanel, setIsCollapsiblePanel] = useState(true)
  const [isBasicInfoChanged, setIsBasicInfoChanged] = useState(false)
  const [isCardInfoChanged, setIsCardInfoChanged] = useState(false)
  const [isCheckInfoChanged, setIsCheckInfoChanged] = useState(false)
  const [isAchInfoChanged, setIsAchInfoChanged,] = useState(false)
  const [showAddNewContact, setShowAddNewContact] = useState(false)
  const [contactDataFromField, setContactDataFromField] = useState({})
  const [isMasterSupplierId, setIsMasterSupplierId] = useState('');

  useEffect(() => {
    if (!isFromExistingMaster) {
      if (masterSupplierId) {
        history.push('/suppliers/' + masterSupplierId);
        setIsMasterSupplierId(masterSupplierId);
      } else if (masterSupplierDetails.baseInfo.id) {
        history.push('/suppliers/' + masterSupplierDetails.baseInfo.id);
        setIsMasterSupplierId(masterSupplierDetails.baseInfo.id);
      } else {
        history.push('/suppliers/');
      }
      setIsCollapsiblePanel(collapsiblePanel);
    }
  }, [masterSupplierId, history, masterSupplierDetails, collapsiblePanel]);

  const cardColumns = [
    {
      name: 'isAcceptAmericanExpress',
      label: 'Accepts American Express',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMasterCard',
      label: 'Accepts Mastercard',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisa',
      label: 'Accepts Visa',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForAmericanExpress',
      label: 'Has Acceptance Conditions for American Express',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForMastercard',
      label: 'Has Acceptance Conditions for Mastercard',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForVisa',
      label: 'Has Acceptance Conditions for Visa',
      datatype: 'boolean'
    },
    {
      name: 'hasAcceptanceConditionForDiscover',
      label: 'Has Acceptance Conditions for Discover',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByEmail',
      label: 'Accepts Card Payment by Email',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByFax',
      label: 'Accepts Card Payment by Fax',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByPhone',
      label: 'Accepts Card Payment by Phone',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardPaymentByOnlinePortal',
      label: 'Accepts Card Payment by Online Portal',
      datatype: 'boolean'
    },
    {
      name: 'americanExpressPercentFee',
      label: 'American Express % Fee',
      datatype: 'percent',
    },
    {
      name: 'americanExpressDollarFee',
      label: 'American Express $ Fee',
      datatype: 'currency',
    },
    {
      name: 'americanExpressMinPaymnet',
      label: 'American Express Min Payment',
      datatype: 'currency',
    },
    {
      name: 'americanExpressMaxPayment',
      label: 'American Express Max Payment',
      datatype: 'currency',
    },
    {
      name: 'mastercardPercentFee',
      label: 'Mastercard % Fee',
      datatype: 'percent',
    },
    {
      name: 'mastercardDollarFee',
      label: 'Mastercard $ Fee',
      datatype: 'currency',
    },
    {
      name: 'mastercardMinPayment',
      label: 'Mastercard Min Payment',
      datatype: 'currency',
    },
    {
      name: 'mastercardMaxPayment',
      label: 'Mastercard Max Payment',
      datatype: 'currency',
    },
    {
      name: 'visaPercentFee',
      label: 'Visa % Fee',
      datatype: 'percent',
    },
    {
      name: 'visaDollarFee',
      label: 'Visa $ Fee',
      datatype: 'currency',
    },
    {
      name: 'visaMinPayment',
      label: 'Visa Min Payment',
      datatype: 'currency',
    },
    {
      name: 'visaMaxPayment',
      label: 'Visa Max Payment',
      datatype: 'currency',
    },
    {
      name: 'isCredentialsRequired',
      label: 'IS Credentials Required',
      datatype: 'boolean'
    },
    {
      name: 'cardDiscountValue',
      label: 'Card Discount Value',
    },
    {
      name: 'tokenType',
      label: 'Token Configuration',
    },
    {
      name: 'cardPaymentByPhoneValue',
      label: 'Phone',
      datatype: 'integer',
    },
    {
      name: 'cardPaymentByFaxValue',
      label: 'Fax',
      datatype: 'integer',
    },
    {
      name: 'isAcceptEcommercePortal',
      label: 'E-Commerce',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptPortal',
      label: 'Portal',
      datatype: 'boolean'
    },
    {
      name: 'isAccept3rdPartyPortal',
      label: '3rd Party Portal',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptInAppPortal',
      label: 'In-App',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptPointOfSalePortal',
      label: 'Point of Sale',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardAuthorizationForm',
      label: 'Card Authorization Form',
      datatype: 'boolean'
    },
    {
      name: 'cardAuthorizationFormFile',
      label: 'Card Authorization Form File',
    },
    {
      name: 'thirdPartyPortalUrl',
      label: '3rd Party Portal URL',
    },
    {
      name: 'portalUrl',
      label: 'Portal URL',
    },
    {
      name: 'advancedAcceptanceEnabled',
      label: 'Advanced Acceptance Enabled',
      datatype: 'boolean',
    },
    {
      name: 'amexProcessingFeeType',
      label: 'Amex Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexProcessingFeeValue',
      label: 'Amex Processing Fee Value',
    },
    {
      name: 'amexMinPaymentFeeType',
      label: 'Amex Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexMinPaymentFeeValue',
      label: 'Amex Minimum Payment Fee Value',
    },
    {
      name: 'amexMaxPaymentFeeType',
      label: 'Amex Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexMaxPaymentFeeValue',
      label: 'Amex Maximum Payment Fee Value',
    },
    {
      name: 'amexIncrementalFeeType',
      label: 'Amex Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexIncrementalFeeValue',
      label: 'Amex Incremental Fee Value',
    },
    {
      name: 'amexIncrementalPaymentAmount',
      label: 'Amex Incremental Payment Amount',
    },
    {
      name: 'visaProcessingFeeType',
      label: 'Visa Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaProcessingFeeValue',
      label: 'Visa Processing Fee Value',
    },
    {
      name: 'visaMinPaymentFeeType',
      label: 'Visa Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaMinPaymentFeeValue',
      label: 'Visa Minimum Payment Fee Value',
    },
    {
      name: 'visaMaxPaymentFeeType',
      label: 'Visa Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaMaxPaymentFeeValue',
      label: 'Visa Maximum Payment Fee Value',
    },
    {
      name: 'visaIncrementalFeeType',
      label: 'Visa Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaIncrementalFeeValue',
      label: 'Visa Incremental Fee Value',
    },
    {
      name: 'visaIncrementalPaymentAmount',
      label: 'Visa Incremental Payment Amount',
    },
    {
      name: 'mastercardProcessingFeeType',
      label: 'Mastercard Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardProcessingFeeValue',
      label: 'Mastercard Processing Fee Value',
    },
    {
      name: 'mastercardMinPaymentFeeType',
      label: 'Mastercard Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardMinPaymentFeeValue',
      label: 'Mastercard Minimum Payment Fee Value',
    },
    {
      name: 'mastercardMaxPaymentFeeType',
      label: 'Mastercard Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardMaxPaymentFeeValue',
      label: 'Mastercard Maximum Payment Fee Value',
    },
    {
      name: 'mastercardIncrementalFeeType',
      label: 'Mastercard Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardIncrementalFeeValue',
      label: 'Mastercard Incremental Fee Value',
    },
    {
      name: 'mastercardIncrementalPaymentAmount',
      label: 'Mastercard Incremental Payment Amount',
    },
    {
      name: 'isAcceptCardPaymentTerms',
      label: 'Accepts Card Payment Terms',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptCardDiscount',
      label: 'Accepts Card Discount',
      datatype: 'boolean'
    },
    {
      name: 'cardPaymentTermsvalue',
      label: 'Payment Terms',
    },
    {
      name: 'cardDiscountType',
      label: 'Card Discount Type',
    },
    {
      name: 'discoverProcessingFeeType',
      label: 'Discover Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverProcessingFeeValue',
      label: 'Discover Processing Fee Value',
    },
    {
      name: 'discoverMinPaymentFeeType',
      label: 'Discover Minimum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverMinPaymentFeeValue',
      label: 'Discover Minimum Payment Fee Value',
    },
    {
      name: 'discoverMaxPaymentFeeType',
      label: 'Discover Maximum Payment Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverMaxPaymentFeeValue',
      label: 'Discover Maximum Payment Fee Value',
    },
    {
      name: 'discoverIncrementalFeeType',
      label: 'Discover Incremental Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'discoverIncrementalFeeValue',
      label: 'Discover Incremental Fee Value',
    },
    {
      name: 'discoverIncrementalPaymentAmount',
      label: 'Discover Incremental Payment Amount',
    },
    {
      name: 'cardPhoneExtension',
      label: 'Card Phone Extension',
    },
    {
      name: 'isAcceptAcceptancePerCard',
      label: 'Accepts Acceptance Per Card',
      datatype: 'boolean'
    },
    {
      name: 'amexSecondProcessingFeeType',
      label: 'Amex Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'amexSecondProcessingFeeValue',
      label: 'Amex Second Processing Fee Value',
    },
    {
      name: 'visaSecondProcessingFeeType',
      label: 'Visa Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'visaSecondProcessingFeeValue',
      label: 'Visa Second Processing Fee Value',
    },
    {
      name: 'mastercardSecondProcessingFeeType',
      label: 'Master Second Processing Fee Type',
      datatype: 'feetype'
    },
    {
      name: 'mastercardSecondProcessingFeeValue',
      label: 'Master Second Processing Fee Value',
    },
    {
      name: 'isAcceptProductSpecific',
      label: 'Accepts Card Product Specific',
      datatype: 'boolean'
    },
    {
      name: 'productSpecificOptions',
      label: 'Product Specific Options',
    },
    {
      name: 'isAcceptPOTSPhone',
      label: 'Accepts POTS Phone',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptIVRPhone',
      label: 'Accepts IVR Phone',
      datatype: 'boolean'
    },
    {
      name: 'cardPaymentIVRPhone',
      label: 'IVR Phone',
      datatype: 'integer',
    },
    {
      name: 'isAcceptAmexVariableFee',
      label: 'Accepts Amex Variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisaVariableFee',
      label: 'Accepts Visa variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMasterCardVariableFee',
      label: 'Accepts MasterCard Variable Fee',
      datatype: 'boolean'
    },
    {
      name: 'emailRemitRequirements',
      label: 'Email Remittance Requirements',
    },
    {
      name: 'phoneRemitRequirements',
      label: 'Phone Remittance Requirements',
    },
    {
      name: 'faxRemitRequirements',
      label: 'Fax Remittance Requirements',
    },
    {
      name: 'onlineRemitRequirements',
      label: 'Online Remittance Requirements',
    },
    {
      name: 'posRemitRequirements',
      label: 'POS Remittance Requirements',
    },
    {
      name: 'isAcceptAmexCardConditions',
      label: 'Accepts Amex Card Conditions',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptVisaCardConditions',
      label: 'Accepts Visa Card Conditions',
      datatype: 'boolean'
    },
    {
      name: 'isAcceptMastercardCardConditions',
      label: 'Accepts Mastercard Card Conditions',
      datatype: 'boolean'
    }
  ]

  const achColumns = [
    {
      name: 'isAcceptAchPayments',
      label: 'Accept ach payments',
    },
    {
      name: 'achInstructions',
      label: 'Ach Instructions',
    },
    {
      name: 'bankAccountNumber',
      label: 'Bank Account Number',
    },
    {
      name: 'bankRoutingNumber',
      label: 'Bank Routing Number',
    },
    {
      name: 'emailAch',
      label: 'Email Ach',
    },
    {
      name: 'bankName',
      label: 'Bank Name',
    },
    {
      label: 'Is ACH Paid Through Portal?',
      name: 'isAchThroughPortal'
    },
    {
      label: 'ACH Portal URL',
      name: 'achPortalURL'
    }
  ]

  const historyTabs = [
    {
      label: 'All',
      value: 'all',
    },
    {
      label: 'Notes',
      value: 'notes',
    },
    {
      label: 'Files',
      value: 'files',
    },
    {
      label: 'Change Log',
      value: 'changelog',
    },
    {
      label: 'Call Recordings',
      value: 'callRecordings',
    },
    {
      label: 'Email',
      value: 'email',
    }
  ]

  const checkColumns = [
    {
      label: 'Do they accept Check payments?',
      name: 'isAcceptCheckPayments',
      defaultValue: false,
      datatype: 'boolean'
    },
    {
      label: 'Do they offer Cash Discount?',
      name: 'isAcceptCashDiscount',
      defaultValue: false,
      datatype: 'boolean'
    },
    {
      label: 'Cash Discount Type?',
      name: 'cashDiscountType',
      defaultValue: 'Percentage',
    },
    {
      label: 'Cash Discount Value?',
      name: 'cashDiscountValue',
      defaultValue: '',
    },
    {
      label: 'Check Remittance Address matches Supplier Address?',
      name: 'isMatchVendorAddress',
      defaultValue: false,
    },
    {
      label: 'Check Address Line 1',
      name: 'checkAddress1',
      defaultValue: '',
    },
    {
      label: 'Check Address Line 2',
      name: 'checkAddress2',
      defaultValue: '',
    },
    {
      label: 'Check City',
      name: 'checkCity',
      defaultValue: '',
    },
    {
      label: 'Check State',
      name: 'checkState',
      defaultValue: '',
    },
    {
      label: 'Check Zip',
      name: 'checkZip',
      defaultValue: '',
    },
    {
      label: 'Check Country',
      name: 'checkCountry',
      defaultValue: '',
    },
    {
      label: 'Payment Terms',
      name: 'cashPaymentTermsValue',
      defaultValue: 'Upon Receipt',
    },
  ]

  const checkedRelatedSupplierRow = (data) => {
    checkedRelatedSupplierData({ data, isAcceptGlobalAcceptance: masterSupplierDetails?.cardInfo?.isAcceptGlobalAcceptance });
  };

  const handleGlobalAcceptanceChange = (checked) => {
    if (checked || checked === null) {
      setIsCollapsiblePanel(true)
    } else {
      setIsCollapsiblePanel(false)
    }
  }

  const PanelHeader = (headerText) => {
    return (
      <h4 className={`mb-0${isFromExistingMaster ? ' p-0' : ''}`}> {headerText} </h4>
    )
  }

  const tabs = [
    { label: 'Supplier Info', value: 'basic' },
    { label: 'Contacts', value: 'contacts' },
    { label: 'Card Acceptance', value: 'card' },
    { label: 'Check Acceptance', value: 'check' },
    { label: 'ACH Acceptance', value: 'ach' }
  ]
  const [currentTab, setCurrentTab] = useState('basic')
  const [showCreateChild, setShowCreateChild] = useState(false)

  const handleClickTab = (tab) => {
    if (isFromExistingMaster) {
      if ((currentTab === 'basic' && isBasicInfoChanged) || (currentTab === 'card' && isCardInfoChanged) || (currentTab === 'check' && isCheckInfoChanged) || (currentTab === 'ach' && isAchInfoChanged)) {
        toast.show({
          title: 'Warning',
          description: 'Please save the information!',
        })
        return
      }
    }
    tab !== currentTab && setCurrentTab(tab)
  }

  const handleCreateChild = () => {
    setShowCreateChild(true)
  }

  const handleClose = async (isGetChildData = false, isGetContactsData = false, childId = null) => {
    setShowCreateChild(false)
    if (isGetChildData) {
      dispatch(
        await getChildSuppliersWithMasterId(masterSupplierDetails?.baseInfo?.id)
      ).then(async () => {
        if (isGetContactsData) {
          await getContactsData(childId)
        }
      })
    }
  }

  const handleUpdateCompletenessScore = (supplierId) => {
    if (supplierId) {
      dispatch(updateCompletenessScore(supplierId))
    }
  }

  const handleConfirmClick = async (isMasterSupplierId) => {
    onConfirmClick(isMasterSupplierId)
  }

  const handleAddNewContact = (contactData = {}) => {
    setContactDataFromField(contactData)
    setShowAddNewContact(true)
  }
  const handleCreateContactClose = async (e, isGetContactsData = false, contact = null,) => {
    const contactId = contact?.id || null
    setShowAddNewContact(false)

    if (contactId) {
      if (contactDataFromField?.tab && contactDataFromField?.tab === 'basic') {
        const colName = contactDataFromField?.colName
        await dispatch(
          await updateSupplierBasicInfo({
            supplierId: masterSupplierDetails?.baseInfo?.id,
            basicData: {
              ...masterSupplierDetails?.baseInfo,
              [colName]: contactId
            },
            isUpdateInRedux: false
          })
        ).then(async () => {
          if (basicInfoSaveBtnRef && basicInfoSaveBtnRef?.current) {
            await basicInfoSaveBtnRef?.current?.onCreateContactForEmailPhone(colName, contactId)
            await basicInfoSaveBtnRef?.current?.handleSaveSupplierInfo()
          }
        })
      } else if (contactDataFromField?.tab && contactDataFromField?.tab === 'ach') {
        await dispatch(
          await updateSupplierPaymentInfo({
            masterSupplierId: isMasterSupplierId,
            paymentId: masterSupplierDetails?.paymentInfo?.id,
            paymentData: {
              ...masterSupplierDetails?.paymentInfo,
              'emailAch': contactId
            },
            isUpdateInRedux: false
          })
        ).then(async () => {
          if (achInfoSaveBtnRef && achInfoSaveBtnRef?.current) {
            await achInfoSaveBtnRef?.current?.onCreateContactForEmail(contactId)
            await achInfoSaveBtnRef?.current?.handleClickSave()
          }
        })
      } else if (contactDataFromField?.tab && contactDataFromField?.tab === 'card') {
        const colName = contactDataFromField?.colToUpdate
        const value = colName === 'email' ? contact?.email : contact?.phone

        if (colName !== 'email') {
          await dispatch(
            await updateSupplierCardInfo({
              masterSupplierId: isMasterSupplierId,
              cardId: masterSupplierDetails?.cardInfo?.id,
              cardData: {
                ...masterSupplierDetails?.cardInfo,
                [colName]: contactId
              },
              isCardAcceptanceUpdated: true,
              isUpdateInRedux: false
            })
          ).then(async () => {
            if (cardInfoSaveBtnRef && cardInfoSaveBtnRef?.current) {
              await cardInfoSaveBtnRef?.current?.onCreateContactForEmailPhone(colName, contactId, value)
              await cardInfoSaveBtnRef?.current?.handleSave()
            }
          })
        } else {
          await cardInfoSaveBtnRef?.current?.onCreateContactForEmailPhone(colName, contactId, value)
        }
      }
    }

    setContactDataFromField({})
    if (isGetContactsData) {
      await getContactsData()
    }
  }

  const getContactsData = async (childId = null) => {
    let supplierIds = [masterSupplierDetails?.baseInfo?.id]
    if (masterSupplierDetails?.childVendors && masterSupplierDetails?.childVendors?.length > 0) {
      const childIds = masterSupplierDetails?.childVendors?.map(sup => sup?.id)
      if (childIds && childIds?.length > 0) {
        supplierIds = [...supplierIds, ...childIds]
      }
    }
    if (childId) {
      supplierIds?.push(childId)
    }
    if (supplierIds?.length) {
      await dispatch(getContacts({ supplierIds }))
    }
  }

  useEffect(() => {
    getSubscriptions()
  }, []);

  return (
    <div className='position-relative'>
      {((isMasterSupplierId || masterSupplierDetails?.baseInfo?.id) && isMasterSupplierId !== null && masterSupplierDetails?.baseInfo?.id) ?
        <div className={`assign-vendor-supply ${(isLoadingMasterDetail || isLoadingChildSupplier || isLoadingSupplierContacts) ? 'loading' : ''}`}>
          {(isLoadingMasterDetail || isLoadingChildSupplier || isLoadingSupplierContacts) && <LoaderComponent />}

          <MasterSupplierHealth
            qaStatus={qaStatus}
            supplierData={masterSupplierDetails}
          />

          {!isFromExistingMaster && (
            <div className='master-supplier-history mb-5'>
              <MasterSupplierHistory
                historyTabs={historyTabs}
                callers={callers}
              />
            </div>
          )}
          <div className={`list-tabs d-flex align-items-end border border-top-0 border-start-0 border-end-0 border-1${isFromExistingMaster ? ' my-5' : ''}`}>
            {
              tabs.map(tab => (
                <button
                  key={tab.value}
                  type="button"
                  className={`h4 border border-1 border-bottom-0 rounded-top mb-0 page-tab list-tab pt-2 pb-2 p-4 text-black fw-bold me-3${currentTab === tab.value ? ' selected bg-dark-blue text-white pt-3 pb-3' : ''}`}
                  onClick={() => { handleClickTab(tab.value) }}
                  disabled={isLoadingMasterDetail || isLoadingChildSupplier || isLoadingSupplierContacts}
                >
                  {tab.label}
                </button>
              ))
            }
            {currentTab === 'contacts' && (
              <div role="button" className='ms-auto d-flex gap-2 mb-2 me-2'>
                <button
                  type="button"
                  className="fs-4 text-white rounded ps-5 pe-5 py-3 ps-sm-5 pe-sm-5 bg-dark-blue"
                  onClick={() => { handleAddNewContact({}) }}
                  disabled={isLoadingMasterDetail || isLoadingChildSupplier || isLoadingSupplierContacts}
                >
                  Create Contact
                </button>
              </div>
            )}
          </div>

          {currentTab === 'basic' && (
            <SupplyInformation
              ref={basicInfoSaveBtnRef}
              masterSupplierId={isMasterSupplierId ? parseInt(isMasterSupplierId) : masterSupplierDetails?.baseInfo?.id}
              onUpdateCompletenessScore={handleUpdateCompletenessScore}
              onInfoChange={(value) => { setIsBasicInfoChanged(value) }}
              onCreateContact={handleAddNewContact}
              onGetAllContactsData={getContactsData}
            />
          )}

          {currentTab === 'contacts' && (
            <Contacts contactsData={masterSupplierDetails?.contacts} onGetContactsData={handleCreateContactClose} />
          )}

          {currentTab === 'card' && (
            <Panel header={PanelHeader('Acceptance Information')} className={`supply-card-acceptance bg-white mt-0  ${!isCollapsiblePanel ? 'hide-panel' : ''}`} defaultExpanded={isCollapsiblePanel} collapsible bordered>
              <div className="supply-acceptance flex-column flex-xl-row flex-nowrap flex-md-wrap">
                <div className="col me-0 me-xl-3">
                  <SupplyCardAcceptance
                    ref={cardInfoSaveBtnRef}
                    cardColumns={cardColumns}
                    masterSupplierId={isMasterSupplierId ? parseInt(isMasterSupplierId) : masterSupplierDetails?.baseInfo?.id}
                    onUpdateCompletenessScore={handleUpdateCompletenessScore}
                    onInfoChange={(value) => { setIsCardInfoChanged(value) }}
                    onCreateContact={handleAddNewContact}
                    onGetAllContactsData={getContactsData}
                  />
                </div>
              </div>
            </Panel>
          )}

          {currentTab === 'check' && (
            <Panel header={PanelHeader('Check Acceptance Information')} className={`supply-card-acceptance bg-white mt-0  ${!isCollapsiblePanel ? 'hide-panel' : ''}`} defaultExpanded={isCollapsiblePanel} collapsible bordered>
              <div className="supply-acceptance flex-column flex-xl-row flex-nowrap flex-md-wrap">
                <div className="col me-0 me-xl-3">
                  <SupplyCheckAcceptance
                    checkColumns={checkColumns}
                    masterSupplierId={isMasterSupplierId ? parseInt(isMasterSupplierId) : masterSupplierDetails?.baseInfo?.id}
                    onUpdateCompletenessScore={handleUpdateCompletenessScore}
                    onInfoChange={(value) => { setIsCheckInfoChanged(value) }}
                  />
                </div>
              </div>
            </Panel>
          )}

          {currentTab === 'ach' && (
            <Panel header={PanelHeader('ACH Acceptance Information')} className={`supply-card-acceptance bg-white mt-0  ${!isCollapsiblePanel ? 'hide-panel' : ''}`} defaultExpanded={isCollapsiblePanel} collapsible bordered>
              <div className="supply-acceptance flex-column flex-xl-row flex-nowrap flex-md-wrap">
                <div className="col me-0 me-xl-3">
                  <SupplyAchAcceptance
                    ref={achInfoSaveBtnRef}
                    achColumns={achColumns}
                    masterSupplierId={isMasterSupplierId ? parseInt(isMasterSupplierId) : masterSupplierDetails?.baseInfo?.id}
                    onUpdateCompletenessScore={handleUpdateCompletenessScore}
                    onInfoChange={(value) => { setIsAchInfoChanged(value) }}
                    onCreateContact={handleAddNewContact}
                    onGetAllContactsData={getContactsData}
                  />
                </div>
              </div>
            </Panel>
          )}

          {!isFromExistingMaster && (
            <>
              <SupplyChildVendor
                checkedRelatedSupplierRow={checkedRelatedSupplierRow}
                isFromExistingMaster={isFromExistingMaster}
                onCreateChild={handleCreateChild}
              />
              <SupplierHistoricalPayments />
            </>
          )}
        </div>
        :
        <div className={`assign-vendor-supply`}>
          <h4 className="no-data text-black mb-0 fw-bold"> No data found. Please select any master supplier record to view the Information of Master Supplier. </h4>
        </div>
      }
      {showCreateChild && !isFromExistingMaster && (
        <>
          <ModalComponent size='xl' modalTitle='Create Child' open={showCreateChild} handleClose={() => { handleClose(false) }} dialogClassName='create-child-modal-dialog'
          >
            <CreateChildVendorFromMaster
              masterSupplierData={masterSupplierDetails?.baseInfo}
              contacts={masterSupplierDetails?.contacts || []}
              onClose={handleClose}
            />
          </ModalComponent>
        </>
      )}
      {isFromExistingMaster && (
        <div className='position-sticky bottom-0 text-end'>
          <button className='bg-dark-blue h4 mb-0 rounded text-white p-5 pt-3 pb-3 mt-3'
            disabled={isBasicInfoChanged || isCardInfoChanged || isCheckInfoChanged || isAchInfoChanged}
            onClick={() => { handleConfirmClick(isMasterSupplierId ? parseInt(isMasterSupplierId) : masterSupplierDetails?.baseInfo?.id) }}
          > Confirm </button>
        </div>
      )}
      {showAddNewContact && (
        <>
          <ModalComponent size='xl' modalTitle='' open={showAddNewContact} handleClose={handleCreateContactClose} dialogClassName='px-5 create-new-contact-modal-dialog'>
            <CreateContact onClose={handleCreateContactClose} supplierId={masterSupplierDetails?.baseInfo?.id} contactDataFromField={contactDataFromField} />
          </ModalComponent>
        </>
      )}
    </div>
  )
}
export default SupplyComponent